import { pilot } from '~/services/serviceInstances';

export const enableWellKnownFields = async (): Promise<void> => {
  await pilot.post('client/well-known-fields/');
};
